
const PageNotFound = () => {
  return (
    <> PageNotFound</>
  )
}

export default PageNotFound